import FeatureCard from "../FeatureCard"
import { BarChart3, Car, Printer, Smartphone, ShieldCheck, Headset } from "lucide-react"

const BenefitsGrid = ({ benefits }) => (
  <div className="benefits-grid-ini">
    {benefits.map((benefit, index) => (
      <FeatureCard key={index} icon={benefit.icon} title={benefit.title} description={benefit.description} />
    ))}
  </div>
)

const BenefitsCTA = () => <div className="benefits-cta-ini"></div>

export default function BeneficiosSection() {
  const benefits = [
    {
      icon: <BarChart3 size={24} />,
      title: "Control total de ingresos",
      description:
        "Monitorea en tiempo real todos los ingresos de tu parqueadero. Genera reportes detallados por períodos, métodos de pago y tipos de vehículos.",
    },
    {
      icon: <Car size={24} />,
      title: "Administración eficiente",
      description:
        "Visualiza la ocupación de tu parqueadero en tiempo real. Optimiza la distribución de espacios y mejora la rotación de vehículos.",
    },
    {
      icon: <Printer size={24} />,
      title: "Impresión automática de tickets",
      description:
        "Sistema de impresión de tickets con códigos QR que agiliza el proceso de entrada y salida, reduciendo tiempos de espera.",
    },
    {
      icon: <Smartphone size={24} />,
      title: "Aplicación intuitiva",
      description:
        "Interfaz amigable tanto para administradores como para operadores. Capacitación mínima requerida para su uso.",
    },
    {
      icon: <ShieldCheck size={24} />,
      title: "Seguridad avanzada",
      description:
        "Control de acceso con registro fotográfico de vehículos. Respaldos automáticos en la nube para proteger tu información.",
    },
    {
      icon: <Headset size={24} />,
      title: "Soporte técnico 24/7",
      description:
        "Equipo de soporte disponible todos los días para resolver cualquier incidencia y garantizar la continuidad de tu operación.",
    },
  ]

  return (
    <section className="benefits-section-ini">
      <div className="container-ini">
        <div className="section-header-ini">
          <h2 className="section-title-ini">Ventajas de elegir Parking Club</h2>
          <p className="section-description-ini">
            Nuestro sistema integral ofrece múltiples beneficios que transformarán la operación de tu parqueadero.
          </p>
        </div>
        <BenefitsGrid benefits={benefits} />
        <BenefitsCTA />
      </div>
    </section>
  )
}
